import {
  APP_ALERT_MODULE,
  DATA_ACCESS_ALL_STATUS,
  DATA_ACCESS_STATUS,
  DATA_ACCESS_STATUS_TO_ALERT_TYPE_MAPPER,
} from "@/constants";
import type { DataAccessListItem } from "@/model/data-access";

export const hasDataAccess = (
  memberIdToCheck: string,
  accessListArr: DataAccessListItem[],
  {
    isFromCareHistory = false,
    selfMemberId,
  }: { isFromCareHistory?: boolean; selfMemberId?: string } = {},
) => {
  if (accessListArr !== null && accessListArr?.length > 0) {
    let accessMap;
    if (selfMemberId) {
      // checks if dependent's data is shared with the member(self)
      const filteredAccessList = accessListArr.filter(
        (item) => item.grantedTo === selfMemberId,
      );
      accessMap = new Map(
        filteredAccessList.map((entry) => [entry.grantedBy, entry.status]),
      );
    } else {
      accessMap = isFromCareHistory
        ? new Map(accessListArr.map((entry) => [entry.grantedBy, entry.status]))
        : new Map(
            accessListArr.map((entry) => [entry.grantedTo, entry.status]),
          );
    }
    const status = accessMap.get(memberIdToCheck);
    if (!status || DATA_ACCESS_STATUS.DENIED.has(status))
      return { hasAccess: false, status };
    return { hasAccess: true, status };
  }
};

export const getQueue = (
  dataAccessList: DataAccessListItem[],
  selfMemberId: string,
) => {
  if (selfMemberId && dataAccessList) {
    return dataAccessList
      ?.filter(
        (item) =>
          (item.grantedTo === selfMemberId &&
            item.status === DATA_ACCESS_ALL_STATUS.GRANTED) ||
          (item.grantedBy === selfMemberId &&
            (item.status === DATA_ACCESS_ALL_STATUS.ACCEPTED ||
              item.status === DATA_ACCESS_ALL_STATUS.DECLINED)),
      )
      .map((item) => ({
        contentType:
          DATA_ACCESS_STATUS_TO_ALERT_TYPE_MAPPER[
            item.status as keyof typeof DATA_ACCESS_STATUS_TO_ALERT_TYPE_MAPPER
          ],
        module: APP_ALERT_MODULE.DATA_ACCESS,
        ...item,
      }));
  }
  return [];
};

export const sanitizeHtmlWithPlaceholders = (
  htmlContent: string,
  placeholder?: string,
  placeholderReplacement?: string,
) => {
  let sanitizedHtml = htmlContent;
  if (placeholder && placeholderReplacement) {
    const regex = new RegExp(`\\$\\{${placeholder}\\}`, "g");
    sanitizedHtml = sanitizedHtml.replace(regex, placeholderReplacement);
  }
  const doc = new DOMParser().parseFromString(sanitizedHtml, "text/html");
  return doc.body.innerHTML;
};
